import { render, staticRenderFns } from "./ManTGXDashboard.vue?vue&type=template&id=f500998e&"
import script from "./ManTGXDashboard.vue?vue&type=script&lang=js&"
export * from "./ManTGXDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports